import React, { useEffect } from "react";
import _ from 'lodash';
import { WizardPage } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { MLHVQStepsUtil } from 'ml-services-common-react';

import metadata from './MLPAHVQConsumerDiscrepanciesCheck.metadata.json5';

// First page to set as a parent page for hvq steps after Quote step for progress bar
function MLPAHVQConsumerDiscrepanciesCheck(props) {
    const { goNext, wizardData: submissionVM, steps, changeNextSteps, isSkipping } = props;

    const { processPaHVQConsumerDiscrepanciesCheck } = MLHVQStepsUtil;

    const skipOnResumeIf = () => {
        if (!!_.get(submissionVM, 'bindData.policyNumber.value')
            && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
            return true;
        }
        return !(submissionVM.hvqQuoteID_ML && submissionVM.hvqQuoteID_ML.value);
    };

    useEffect(() => {
        if (!isSkipping || (isSkipping && !skipOnResumeIf())) {
            const discrepanciesCheck =  async () => {
                await processPaHVQConsumerDiscrepanciesCheck(submissionVM, 'paHVQConsumerPrefillAndCarfax', steps, changeNextSteps);
                goNext();
            }
            discrepanciesCheck();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <WizardPage
            showPrevious={false}
            showCancel={false}
            showNext={false}
            skipWhen={skipOnResumeIf}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
            />
        </WizardPage>
    );
};

export default MLPAHVQConsumerDiscrepanciesCheck;
